import React from "react";
import "./Footer.css";
import logo from "../assets/Logo6.png";

import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhone,
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaLinkedinIn
} from "react-icons/fa";

import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <footer className="footer">

      {/* ================= TOP ================= */}
      <div className="footer-container">

        {/* LEFT */}
     <div className="footer-logo-wrapper" onClick={() => handleNavigate("/")}>
  <img src={logo} alt="logo" className="footer-logo" />
          <p className="logo1">KHUSHI BAGS</p>
          <p className="footer-desc">
            Leading Eco-Friendly Product Manufacturer in India
          </p>
        </div>

        {/* MIDDLE */}
        <div className="footer-col">
          <h3>Useful Links</h3>

          <p onClick={() => handleNavigate("/")}>Home</p>
          <p onClick={() => handleNavigate("/ourjourney")}>Our Journey</p>
          <p onClick={() => handleNavigate("/contact")}>Contact Us</p>
        </div>

        {/* RIGHT */}
        <div className="footer-col">
          <h3>Contact</h3>

          <div className="footer-item">
            <FaMapMarkerAlt />
            <span>
              A/P, Tal, Ambegaon, Manchar, Chandoli Khurd, Maharashtra 410503
            </span>
          </div>

          <div className="footer-item">
            <FaEnvelope />
            <span>handmadebags.pune@gmail.com</span>
          </div>

          <div className="footer-item">
            <FaPhone />
            <span>+91 95038 73735</span>
          </div>
        </div>

      </div>

      {/* ================= SOCIAL ================= */}
      <div className="footer-social">
        <FaFacebookF />
        <FaInstagram />
        <FaTwitter />
        <FaLinkedinIn />
      </div>

      {/* ================= BOTTOM ================= */}
      <div className="footer-bottom">
        © 2025 All Rights Reserved Khushi Bags Private Limited
      </div>

    </footer>
  );
};

export default Footer;